import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgProductType() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M6 22h14a1 1 0 100-2H6.012C5.55 19.988 5 19.805 5 19c0-.805.55-.988 1.012-1H19a2 2 0 002-2V4c0-1.103-.897-2-2-2H6c-1.206 0-3 .799-3 3v14c0 2.201 1.794 3 3 3zM5 8V5c0-.805.55-.988 1-1h13v12H5V8z",
      fill: "currentColor"
    }, void 0), _jsx("path", {
      d: "M8 7a1 1 0 011-1h7a1 1 0 110 2H9a1 1 0 01-1-1z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
}

export default SvgProductType;